import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--left",
  "use": "icon-arrow--left-usage",
  "viewBox": "0 0 23 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 23 24\" id=\"icon-arrow--left\"><path d=\"M22.997 13.134v-2.18H1.205v2.18h21.792Z\" fill=\"currentColor\" /><path d=\"M1.54 13.585 13.097 2.028 11.557.487-.002 12.044l1.54 1.541Z\" fill=\"currentColor\" /><path d=\"m11.556 23.601 1.541-1.54L1.54 10.502l-1.541 1.541L11.556 23.6Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol